var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-kng-audit-content standard-size-14",
    },
    [
      _vm.courseDelete
        ? [
            _c("div", { staticClass: "standard-size-16 yxt-weight-5" }, [
              _vm._v(_vm._s(_vm.$t("pc_biz_kng_courseinfo" /** 课程信息 */))),
            ]),
            _c("div", { staticClass: "color-gray-7 mt16" }, [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_kng_coursedelete" /** 课程已删除 */))
              ),
            ]),
          ]
        : [
            _vm.coverUrl
              ? _c(
                  "div",
                  { staticClass: "yxtbiz-kng-audit-content__cover" },
                  [
                    _c("yxt-image", {
                      attrs: {
                        src: _vm.coverUrl,
                        width: "100%",
                        height: "100%",
                      },
                    }),
                    _vm.coverUrlIsChange
                      ? _c(
                          "yxt-tag",
                          {
                            staticClass: "yxtbiz-kng-audit-content__cover-tag",
                            attrs: { type: "warning", size: "mini" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_biz_kng_lbl_hadchanged" /** 已更改 */
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.groupList, function (group, gIndex) {
              return _c(
                "div",
                { key: gIndex, class: gIndex > 0 ? "mt32" : "" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "yxtbiz-kng-audit-content__title standard-size-16 yxt-weight-5",
                    },
                    [_vm._v(_vm._s(group.title))]
                  ),
                  _vm._l(group.list, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.label,
                        staticClass:
                          "yxtbiz-kng-audit-content__line standard-size-14",
                        class: index === 0 ? "mt16" : "mt12",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-kng-audit-content__label",
                            class: _vm.labelWidthClass,
                          },
                          [_vm._v(_vm._s(item.label))]
                        ),
                        _c(
                          "div",
                          { staticClass: "yxtbiz-kng-audit-content__text" },
                          [
                            _c("text-node", {
                              attrs: { config: item },
                              on: { preview: _vm.previewCourse },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                ],
                2
              )
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }